export default function StatusBadge({ disposition, status }) {
  const label = disposition || status || "Uninspected";
  const slug = label.toLowerCase().replace(" ", "-");

  return (
    <span className={`status-badge status-${slug}`} data-testid={`status-${slug}`}>
      {label}
    </span>
  );
}